import { linkOptions, useParams } from '@tanstack/react-router';

import { Breadcrumbs } from '../../cdl/Breadcrumbs/Breadcrumbs';
import { Text } from '../../cdl/Text/Text';
import { translate } from '../../common/helpers/translate.helper';
import { useDocumentTitle } from '../../common/hooks/useDocumentTitle';
import { useRole } from '../../common/hooks/useRole';
import { Page } from '../../common/Page/Page';
import { Box } from '../../common/ui/Box';

import { InviteUserButton } from './components/InviteUserButton';
import { MembersTable } from './components/MembersTable';

export const MembersPage = () => {
    const role = useRole();

    const { groupId } = useParams({
        from: role.isCustomer() ? '/_app/customer-groups/$groupId/members' : '/_app/supplier-groups/$groupId/members',
    });

    useDocumentTitle(translate('page.membersOverview'));

    return (
        <Page>
            {/* A defined height is needed to make the scrolling table work, 60px is the topbar, 80px is the vertical page padding */}
            <Box display="flex" flexDirection="column" height="calc(100vh - 60px - 80px)" gap={40}>
                <Box>
                    <Breadcrumbs
                        links={[{ label: translate('settings.title'), linkOptions: linkOptions({ to: '/settings' }) }]}
                    />
                    <Box marginTop={4} display="flex" justifyContent="space-between" alignItems="center" gap={16}>
                        <Text variant="headline" as="h1">
                            {translate('members')}
                        </Text>
                        {role.hasAnyAdminRights() ? <InviteUserButton /> : null}
                    </Box>
                </Box>

                <Box flex="1" minHeight={0} display="flex" flexDirection="column">
                    <MembersTable groupId={groupId} />
                </Box>
            </Box>
        </Page>
    );
};
